/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Agents_LabelInputs */

const en_cap_agents_label = /** @type {(inputs: Cap_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent teams`)
};

const lv_cap_agents_label = /** @type {(inputs: Cap_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aģentu komandas`)
};

/**
* | output |
* | --- |
* | "Agent teams" |
*
* @param {Cap_Agents_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_agents_label = /** @type {((inputs?: Cap_Agents_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Agents_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_agents_label(inputs)
	return en_cap_agents_label(inputs)
});